import { useState } from '@wordpress/element'; 
import { __ } from '@wordpress/i18n';
import { __experimentalHStack as HStack,
    __experimentalText as Text,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
    Button, Popover,
    __experimentalVStack as VStack,
} from '@wordpress/components';

const Slidereffect = ({ imageanimationValue, onimageAnimationChange,loop,slidesPerView }) => {
    const [isimageVisible, setIsimageVisible] = useState(false);
    const [imagepopoverAnchor, setimagePopoverAnchor] = useState();
    const [imageselectedAnimation, imagesetSelectedAnimation] = useState(imageanimationValue || 'none'); // Default to 'none'

    // Function to toggle the visibility of the popover
    const imagetoggleVisible = () => {
        setIsimageVisible((prev) => !prev);
    };

    const handleimageAnimationClick = (animation) => {
        imagesetSelectedAnimation(animation);
        onimageAnimationChange(animation); // Update the parent component with the new animation value
    };

    let imagename = '';
    const imageanimationoptions = [
        { label: __('Slide', 'vayu_blocks'), value: 'none' },
        { label: __('Fade', 'vayu_blocks'), value: 'fade' },
        { label: __('Coverflow', 'vayu_blocks'), value: 'coverflow' },
        { label: __('Flip', 'vayu_blocks'), value: 'flip' },
        { label: __('Cards', 'vayu_blocks'), value: 'cards' },
    ];

    // Find the label based on imageselectedAnimation
    const imageselectedOption = imageanimationoptions.find(option => option.value === imageselectedAnimation);
    
    if (imageselectedOption) {
        imagename = imageselectedOption.label;
    }

    return (
        <div className="vayu_blocks_animation_panel">
            <ToolsPanel label={__('Slider Effect')} className="vayu_block_animation_name">
                <ToolsPanelItem
                    className="vayu_blocks_animation_toolspanel_item"
                    hasValue={() => !!imageanimationValue}
                    label={__('Effect')}
                    onDeselect={() => onimageAnimationChange(undefined)}
                    isShownByDefault
                >
                    <Button
                        ref={setimagePopoverAnchor}
                        onClick={imagetoggleVisible}
                        className={`block-editor-panel-animation-settings__dropdown ${isimageVisible ? 'is-open' : ''}`}
                    >
                        <HStack alignment="left">
                            <Text>{__(imagename)}</Text>
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isimageVisible && (
                <Popover
                    placement="left-start"
                    className="vayu_blocks_toolspanel_items_popover"
                    anchor={imagepopoverAnchor}
                    onClose={() => setIsimageVisible(false)}
                    offset={35}
                    resize
                >
                   <VStack  style={{padding:'10px',width: '280px'}}>
                        <Text>
                            <h4>{__('Slider Effect')}</h4>
                            <p>{__('Select an animation effect for your element.')}</p>
                        </Text>
                        <Text>
                            <HStack  spacing="2" wrap={true}>
                                <Text
                                    key={'slide'}
                                    className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'none' ? 'selected' : ''}`}
                                    onClick={() => handleimageAnimationClick('none')}
                                    title={'slide'}
                                >
                                    <div className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-none `}>
                                    <h4>Slide</h4>
                                    </div>
                                </Text>

                                {(loop===false) && (
                                    <>
                                        <Text
                                            key={'fade'}
                                            className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'fade' ? 'selected' : ''}`}
                                            onClick={() => handleimageAnimationClick('fade')}
                                            title={'fade'}
                                        >
                                            <div className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-fade`}>
                                            <h4>Fade</h4>
                                            </div>
                                        </Text>
                                    </>
                                )}
                                
                                {slidesPerView < 2 && (
                                    <>

                                        <Text
                                            key={'flip'}
                                            className={`vayu_blocks_animation_panel_button_svg  vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'flip' ? 'selected' : ''}`}
                                            onClick={() => handleimageAnimationClick('flip')}
                                            title={'flip'}
                                        >
                                            <div className={`vayu_blocks_animation_panel_svg  vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-flip`}>
                                            <h4>Flip</h4>
                                            </div>
                                        </Text>


                                        <Text
                                            key={'cards'}
                                            className={`vayu_blocks_animation_panel_button_svg vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'cards' ? 'selected' : ''}`}
                                            onClick={() => handleimageAnimationClick('cards')}
                                            title={'cards'}
                                        >
                                            <div className={`vayu_blocks_animation_panel_svg vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-cards`}>
                                                <h4>Cards</h4>
                                            </div>
                                        </Text>
                                    
                                    </>
                                )}
                            
                                <Text
                                    key={'coverflow'}
                                    className={`vayu_blocks_animation_panel_button_svg  vayu_blocks_animation_panel_button_svg-effect ${imageselectedAnimation === 'coverflow' ? 'selected' : ''}`}
                                    onClick={() => handleimageAnimationClick('coverflow')}
                                    title={'coverflow'}
                                >
                                    <div className={`vayu_blocks_animation_panel_svg  vayu_blocks_animation_panel_svg-effect vayu-blocks-effect-slider-coverflow`}>
                                    <h4>Coverflow</h4>
                                    </div>
                                </Text>
                            </HStack>
                        </Text>
                        
                    </VStack>
                </Popover>
            )}
            
        </div>
    );
};

export default Slidereffect;